export const createStorage = (key) => ({
  get: () => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      console.error(`Unable to get item ${key} from local storage`, e);
      return null;
    }
  },
  set: (value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Unable to set item ${key} to local storage`, e);
    }
  },
});
